// extracted by mini-css-extract-plugin
export var modalFooter = "_sc-0";